function Payment(axios, baseUrl) {
    
    this.axios = axios;
    this.baseUrl = `${baseUrl}membershipFee`;

    this.get = function(id) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/${id}`);
    }
    this.getByIndex = function(index) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/getByIndex/${index}`);
    }
    this.filterByYearAndMonth = function(pageNumber,date,month) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/filterByYearAndMonth/${pageNumber}/${date}/${month}`);
    }
    this.filterByUser = function(pageNumber,userId) {
        let self = this;
        return self.axios.get(`${self.baseUrl}/filterByUser/${pageNumber}/${userId}`);
    }
    this.add = function(model) {
        let self = this;
        return self.axios.post(`${self.baseUrl}`, model);
    }
    this.update = function(model) {
        let self = this;
        return self.axios.put(`${self.baseUrl}`, model);
    }
    this.remove = function(id) {
        let self = this;
        return self.axios.delete(`${self.baseUrl}/${id}`);
    }
}

export default Payment